import axios from 'axios'

export default axios.create({
  baseURL: 'https://www.jbvalves.net/jb/app',
 // baseURL: 'http://127.0.0.1:8208/jb-service/app',
  timeout: 10000,
  headers: {}
})



// WEBPACK FOOTER //
// ./src/api/index.js